<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Configuração de Rolos</mat-label>
                                <mat-select #txtConfiguracao_rolos formControlName="Configuracao_rolos"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterConfigRolos($event.target.value)">
                                    <mat-option *ngFor="let item of listConfigRolos" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo de Calha</mat-label>
                                <mat-select #txtTipo_calha formControlName="Tipo_calha" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterTipoCalha($event.target.value)">
                                    <mat-option *ngFor="let item of listTipoCalha" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">APC Ligado?</mat-label>
                                <input matInput id="txtApc_ligado" class="InputBlockColor"
                                #txtApc_ligado maxlength="20" formControlName="apc_ligado" readonly
                            >
                            <i matSuffix class="{{iconDisableField}}"></i>
                            <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                            <mat-hint align="end">{{txtApc_ligado.value.length}} / 20</mat-hint>
                            <mat-error>{{hasErrorFormControl(formulario.controls.apc_ligado)}}
                            </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Recobrimento de rolos (%)</mat-label>
                                <input matInput id="txtRecobrimento_rolos" class="InputBlockColor"
                                    #txtRecobrimento_rolos maxlength="20" formControlName="Recobrimento_rolos" readonly
                                >
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtRecobrimento_rolos.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Recobrimento_rolos)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de espigas totais - 1ª contagem</mat-label>
                                <input matInput id="txtNumero_espigas_totais_contagem_1"
                                    #txtNumero_espigas_totais_contagem_1 maxlength="3"
                                    formControlName="Numero_espigas_totais_contagem_1" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtNumero_espigas_totais_contagem_1.value.length}} / 3
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Numero_espigas_totais_contagem_1)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de espigas com palha - 1ª contagem</mat-label>
                                <input matInput id="txtNumero_espigas_com_palha_contagem_1"
                                    #txtNumero_espigas_com_palha_contagem_1 maxlength="3"
                                    formControlName="Numero_espigas_com_palha_contagem_1" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtNumero_espigas_com_palha_contagem_1.value.length}} / 3
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.Numero_espigas_com_palha_contagem_1)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de espigas totais - 2ª contagem</mat-label>
                                <input matInput id="txtNumero_espigas_totais_contagem_2"
                                    #txtNumero_espigas_totais_contagem_2 maxlength="3"
                                    formControlName="Numero_espigas_totais_contagem_2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtNumero_espigas_totais_contagem_2.value.length}} / 3
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Numero_espigas_totais_contagem_2)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de espigas com palha - 2ª contagem</mat-label>
                                <input matInput id="txtNumero_espigas_com_palha_contagem_2"
                                    #txtNumero_espigas_com_palha_contagem_2 maxlength="3"
                                    formControlName="Numero_espigas_com_palha_contagem_2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtNumero_espigas_com_palha_contagem_2.value.length}} / 3
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.Numero_espigas_com_palha_contagem_2)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}" [class.mat-form-field-invalid]="warningValidatorDePalha()">
                              <mat-label class="InputLabelColor">Despalha (%)
                              </mat-label>
                              <input matInput id="txtDespalha" #txtDespalha maxlength="10" formControlName="Despalha"
                                  readonly class="InputBlockColor" currencyMask>
                              <i matSuffix class="{{iconDisableField}}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                              <mat-hint align="end">{{txtDespalha.value.length}} / 10</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.Despalha)}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>